function infoCalc() {
    let calcText = document.querySelector(".textMess"),
        resultBlock = document.querySelector(".calc-price");

    resultBlock.style.visibility = "hidden";
    calcText.style.cssText = "padding-top: 25px; padding-left: 10px; padding-right: 10px;  border: 0px; min-height: 100px; background-color: #f7e7e6; width: 100%; text-align: center; z-index: -1000;";
    calcText.style.display="";
}


export default infoCalc;